import Hogan from "hogan.js";
import searchFilterContainer from "../../templates/common/_searchFilterContainer.htm";
import filterModal from "../../templates/common/filtermodal.htm";
import searchFilter from "../../templates/common/searchFilter.htm";

export default {
    searchFilter: Hogan.compile(searchFilter),
    searchFilterContainer: Hogan.compile(searchFilterContainer),
    filterModal: Hogan.compile(filterModal),
};
